import React, { useEffect, useState, Suspense, useRef } from "react";
import Carousel from "react-spring-3d-carousel";
import { v4 as uuidv4 } from "uuid";
import { useDrag, useGesture } from "react-use-gesture";

import { CarouselSliderStyle, CarouselLegenda } from "./styled";
import CarouselSlideContent from "../CarouselSlideContent/CarouselSlideContent";

const CarouselSliderPerspectivas = ({
  setupCarouselPerspectivas,
  setSetupCarouselPerspectivas,
  imagesListPerspectivas,
}) => {
  const [slides, setSlides] = useState([]);
  const [dragged, _setDragged] = useState(false);
  const draggedRef = useRef(dragged);
  const setDragged = (data) => {
    draggedRef.current = data;
    _setDragged(data);
  };

  const bind = useGesture({
    onDrag: ({
      active,
      movement: [mx],
      direction: [xDir],
      distance,
      cancel,
    }) => {
      if (active && distance > window.innerWidth / 10) {
        let direction = Math.round(xDir);
        setDragged(true);
        cancel();
        // console.log(
        //   "direction",
        //   direction,
        //   "window.innerWidth",
        //   window.innerWidth
        // );
        if (direction === -1) {
          let newIndex = 0;
          // console.log(
          //   "currentSlide",
          //   setupCarouselPerspectivas.currentSlide,
          //   "slidesLength",
          //   setupCarouselPerspectivas.slidesLength
          // );
          if (
            setupCarouselPerspectivas.currentSlide <
            setupCarouselPerspectivas.slidesLength - 1
          ) {
            newIndex = setupCarouselPerspectivas.currentSlide + 1;
            // console.log(newIndex);
          }
          setSetupCarouselPerspectivas((values) => ({
            ...values,
            currentSlide: newIndex,
            goToSlide: newIndex,
          }));
        } else {
          let newIndex = setupCarouselPerspectivas.slidesLength;
          if (setupCarouselPerspectivas.currentSlide > 0) {
            newIndex = setupCarouselPerspectivas.currentSlide - 1;
            // console.log(newIndex);
          }
          setSetupCarouselPerspectivas((values) => ({
            ...values,
            currentSlide: newIndex,
            goToSlide: newIndex,
          }));
        }
      }
    },
  });

  const slidesTemp = imagesListPerspectivas.map((image, index) => {
    const idTrim = image.title.replace(/\s+/g, "") + index;
    return {
      key: uuidv4(),
      content: (
        <CarouselSlideContent
          Style={CarouselSliderStyle}
          Legenda={CarouselLegenda}
          image={image}
          idTrim={idTrim}
          bindProps={bind()}
          onClick={(e) => {
            if (!draggedRef.current) {
              setSetupCarouselPerspectivas((values) => ({
                ...values,
                currentSlide: index,
                goToSlide: index,
              }));
            } else {
              setDragged(false);
            }
          }}
        />
      ),
    };
  });

  useEffect(() => {
    setSlides(slidesTemp);
  }, [imagesListPerspectivas]);

  // useEffect(() => {
  //   console.log(slides);
  // }, [slides]);

  if (setupCarouselPerspectivas) {
    return (
      <Suspense fallback={null}>
        <Carousel
          slides={slides}
          goToSlide={setupCarouselPerspectivas.goToSlide}
          offsetRadius={setupCarouselPerspectivas.offsetRadius}
          showNavigation={setupCarouselPerspectivas.showNavigation}
          animationConfig={setupCarouselPerspectivas.config}
        />
      </Suspense>
    );
  } else {
    return <></>;
  }
};

export default CarouselSliderPerspectivas;
